import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { ILanguage, IResponse, ITranslation } from "../../Models";
import type { ITranslationsRepository } from "./ITranslationsRepository";

export default class TranslationsRepository implements ITranslationsRepository {
    public static $inject = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getLanguages(): Observable<IResponse<ILanguage[]>> {
        return this.httpService.get<ILanguage[]>("profile/languages");
    }

    public getTranslations(languageId: string): Observable<IResponse<ITranslation[]>> {
        // eslint-disable-next-line prefer-template
        return this.httpService.get<ITranslation[]>("languages/" + languageId + "/translations");
    }

    public putTranslation(
        languageId: string,
        translationKey: string,
        translation: ITranslation,
    ): Observable<IResponse<ITranslation>> {
        return this.httpService.put<ITranslation>(
            `languages/${languageId}/translations/${translationKey}/`,
            translation,
        );
    }

    public getUntranslatedKeys(languageId: string): Observable<IResponse<ITranslation[]>> {
        // eslint-disable-next-line prefer-template
        return this.httpService.get<ITranslation[]>("languages/" + languageId + "/translations/untranslated");
    }
}

module("mmRepositories").service("mmTranslationsRepository", TranslationsRepository);
